module.exports = __webpack_public_path__ + "img/leftside_1000.3e37bd36.png";